import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const PricingBand = () => (
  <section
    data-testid="pricing-band"
    className="border-y border-[#233c4d]/30 bg-[#111813]"
  >
    <div className="mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-20">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-end"
      >
        <div>
          <h2
            data-testid="pricing-band-title"
            className="max-w-2xl text-3xl font-medium tracking-tight text-[#f3f5f3] md:text-4xl lg:text-5xl"
          >
            Pay only when you ask.{" "}
            <span className="text-[#889296]">No matter the size of your data.</span>
          </h2>
          <p
            data-testid="pricing-band-note"
            className="mt-4 max-w-xl text-sm leading-relaxed text-[#889296] md:text-base"
          >
            Search compute is charged per query. Storage is billed separately at
            object storage price.
          </p>
        </div>
        <a
          href="https://wondersearch.ai/pricing/"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="pricing-band-link"
          className="group inline-flex shrink-0 items-center gap-2 font-mono text-sm uppercase tracking-[0.15em] text-[#bce8d1] transition-colors duration-200 hover:text-[#edf2f4]"
        >
          See pricing
          <ArrowRight
            className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1"
            aria-hidden="true"
          />
        </a>
      </motion.div>
    </div>
  </section>
);
